// extracted by mini-css-extract-plugin
module.exports = {"packList":"style_packList__3zEHa"};